// #region Imports
import React, { useMemo, useEffect, useState, useCallback } from "react"
import {
  Button,
  Input,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap"
import TableContainer from "../../components/Common/TableContainer"
import { useDispatch } from "react-redux"
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
// #endregion

// #region selectors
import { useAuthIdPersonaAuthenticated } from "../../store/selectors"
// #endregion

// #region actions
import { postDocumentosAddDocumento } from "../../store/actions"
// #endregion

const DocumentosListado = ({ documentos, oPersona, formik, closeFn }) => {
  //
  // #region Init
  // #endregion

  // #region Internal States
  const [description, setdescription] = useState("")
  const [showModalShowInput, setModalShowInput] = useState(false)
  const [docsRestantes, setDocsRestantes] = useState([])
  // #endregion

  // #region useEffect
  useEffect(() => {
    const documentosAcumulados = formik.values["docs"]
      ? [...formik.values["docs"]]
      : []
    const docsFiltrados = filtrarDocumentosCatalogo(
      documentos,
      documentosAcumulados
    )
    setDocsRestantes(docsFiltrados)
  }, [])
  // #endregion

  // #region const-selectors
  const idPersonaAuthenticated = useAuthIdPersonaAuthenticated()
  // #endregion

  // #region react-redux
  const dispatch = useDispatch()
  // #endregion

  // #region functions
  const handlerOnChangeDescription = useCallback(event => {
    setdescription(event.target.value)
  }, [])

  const toggleModal = useCallback(() => {
    if (showModalShowInput) {
      setdescription("")
    }
    setModalShowInput(!showModalShowInput)
  }, [showModalShowInput])

  const handlerAddDocumento = useCallback(
    documentoToAdd => {
      //console.log("documentoToAdd", documentoToAdd)
      if (!documentoToAdd) {
        //console.log("No hay documento", documentoToAdd)
        toast.error("No existe documento que enviar.", {
          autoClose: 2000,
        })
      } else {
        if (documentoToAdd.id_Documento === 13) {
          if (!description || description.length === 0) {
            //console.log("No hay descripcion", documentoToAdd)
            toggleModal()
            return
          }
        }

        if (oPersona.id_Persona > 0) {
          dispatch(
            postDocumentosAddDocumento({
              nombreSolicitud: "adddoctopersona",
              idPersona: oPersona.id_Persona,
              idDocumento: documentoToAdd.id_Documento,
              Descripcion: description,
              idPersonaAuthenticated: idPersonaAuthenticated,
            })
          )
        } else {
          let docToAdd = {}
          if (documentoToAdd.id_Documento === 13) {
            if (!description || description.length === 0) {
              //console.log("No hay descripcion", documentoToAdd)
              toggleModal()
              return
            }
          }
          docToAdd = {
            id_Documento: documentoToAdd.id_Documento,
            description: documentoToAdd.Nombre_Documento,
            Nombre_Documento: documentoToAdd.Nombre_Documento,
            id_Relacion_Persona_Documento: -1,
            Original: 0,
            Copias: 0,
          }
          // Verifica si 'docs' existe y es un arreglo
          //console.log("Verifica si docs existe y es un arreglo")
          let documentosAcumulados = formik.values["docs"]
            ? [...formik.values["docs"]]
            : []
          //console.log("documentosAcumulados: ", documentosAcumulados)

          // Agrega el nuevo documento
          //console.log("Agrega el nuevo documento:: .push(docToAdd)")
          documentosAcumulados.push(docToAdd)

          //console.log("documentosAcumulados: ", documentosAcumulados)

          // Actualiza el campo 'docs' en Formik
          formik.setFieldValue("docs", documentosAcumulados)
          documentosAcumulados = formik.values["docs"]
            ? [...formik.values["docs"]]
            : []
          //console.log("documentosAcumulados: ", documentosAcumulados)
        }
      }
      closeFn()
    },
    [
      description,
      dispatch,
      idPersonaAuthenticated,
      oPersona.idPersona,
      toggleModal,
    ]
  )

  const filtrarDocumentosCatalogo = useCallback(
    (catalogo, documentosPersona) => {
      const idsPersona = new Set(documentosPersona.map(doc => doc.id_Documento))
      return catalogo.filter(doc => !idsPersona.has(doc.id_Documento))
    },
    []
  )

  // #endregion

  // #region useMemo

  const columns = useMemo(
    () => [
      {
        header: "Nombre",
        accessorKey: "Nombre_Documento",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Acción",
        cell: ({ row }) => {
          return (
            <Button
              onClick={() => handlerAddDocumento(row.original)}
              className="btn btn-sm btn-soft-primary"
            >
              <i className="mdi mdi-plus" />
            </Button>
          )
        },
      },
    ],
    [handlerAddDocumento]
  )
  // #endregion

  return (
    <React.Fragment>
      <ToastContainer />
      {/* Descripción - Documento personalizado */}
      <Modal isOpen={showModalShowInput}>
        <ModalHeader>Añadir Documento Personalizado</ModalHeader>
        <ModalBody>
          <Label className="mt-1">
            <h5>Nombre Documento</h5>
          </Label>
          <Input
            id={`input-`}
            type="text"
            value={description}
            onChange={handlerOnChangeDescription}
          />
        </ModalBody>
        <ModalFooter>
          <button
            className="btn btn-primary"
            data-bs-target="#firstmodal"
            onClick={toggleModal}
          >
            Cerrar
          </button>
          <button
            className="btn btn-primary"
            data-bs-target="#firstmodal"
            onClick={() => {
              handlerAddDocumento({
                id_Documento: 13,
                Descripcion: description,
              })
              toggleModal()
            }}
          >
            Agregar
          </button>
        </ModalFooter>
      </Modal>
      <TableContainer
        columns={columns}
        data={docsRestantes || []}
        //isCustomPageSize={false}
        //CustomPageSize={dataServicios.length}
        isGlobalFilter={true}
        isPagination={true}
        SearchPlaceholder="Búsqueda ..."
        tableClass="table-condensed align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline border-top"
        theadClass="table-light"
        pagination="pagination"
        paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
      />
    </React.Fragment>
  )
}

export default DocumentosListado
